import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";

@Component({
    selector: "sidebar-decks",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarDecksButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        super("Decks", SvgIcon.Decks, "decks", false); 
    }
}